<template>
<div>
<div class="container fluid" v-if="user.authenticated && !message">
<div class="row">
<div class="col-md-12">
<p>Please email us specifying the documents you would like.</p>
<b-form @submit.prevent="validateBeforeSubmit" autocomplete="off">
  <div class="row">
    <div class="col">
      <b-form-group label="Choose the documents you would like to receive">
      <b-form-checkbox-group v-model="docRequest.DocumentTypes" name="Document Types" v-validate="'required'" stacked>
        <b-form-checkbox  v-for="(results, index) in documentsDisplay.docDisplayDetails"  :key="index" :value="results.documentDisplayDetail">{{results.documentName}}</b-form-checkbox>
      </b-form-checkbox-group>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Document Types')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Document Types')" class="help is-danger">{{ errors.first('Document Types') }}</span>
    </b-form-group>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <label class="label">Name</label>
      <p class="control has-icon has-icon-right">
      <b-input name="Your Name" v-model="docRequest.Name" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Your Name') }" type="text" placeholder="Name"/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Your Name')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Your Name')" class="help is-danger">{{ errors.first('Your Name') }}</span>
      </p>
    </div>
    <div class="col-md-6">
      <label class="label">Email</label>
      <p class="control has-icon has-icon-right">
        <b-input name="Email" v-model="docRequest.Email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email') }" type="email" placeholder="Email"/>
        <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('name')" class="fa-1x"></font-awesome-icon>
        <span v-show="errors.has('Email')" class="help is-danger">{{ errors.first('Email') }}</span>
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <label class="label">Request</label>
      <p class="control has-icon has-icon-right">
        <b-textarea name="Message" v-model="docRequest.Message" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Message') }" rows="5" type="textarea" placeholder="Message"/>
        <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('name')" class="fa-1x"></font-awesome-icon>
        <span v-show="errors.has('Message')" class="help is-danger">{{ errors.first('Message') }}</span>
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <p class="control">
        <button class="btn btn-primary" type="submit">Submit</button>
      </p>
    </div>
  </div>
</b-form>
</div>
</div>
<div class="row">
<div class="col">
<p>
  To update your ACH information, please fill out this form.<br/>
<b-btn class="btn btn-primary" v-b-modal="modalACH(parentData)">ACH Change Form</b-btn>
</p>
</div>
</div>
</div>
  <div class="container fluid" v-else-if="user.authenticated && message">
    <div class='row'>
      <div class='col' >
        <h4 :class='sentClass'>{{message}}</h4>
      </div>
    </div>
  </div>
  <div class="container fluid" v-else>
    <div class="row">
      <div class="col text-center">
        <h3>Sorry it looks like you've been logged out, please <router-link to="/login">Login</router-link> to resume</h3>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import auth from './auth'
import axios from 'axios'
export default {
  name: 'modalDocuments',
  components: {
  },
  props: {
    parentData: {
      type: Number
    },
    modalid: {
      type: String
    }
  },
  data: function () {
    return {
      docRequest: {
        DocumentTypes: []
      },
      message: '',
      sentClass: '',
      timer: '',
      user: auth.user,
      documentsDisplay: [],
      apiUrl: localStorage.getItem('apiURL')
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // Data is valid, so we can submit the form.
          let uri = this.apiUrl + auth.user.clientID + '/contracts/' + this.parentData + '/documents/documentrequest'
          axios.post(uri, this.docRequest, {headers: auth.getAuthHeader()}).then((response) => {
            this.sentClass = 'text-success'
            this.message = 'Thank you for your document request, we have received it and will process it as quickly as possible.'
            this.docRequest = {}
            this.timer = setTimeout(() => {
              this.$root.$emit('bv::hide::modal', this.modalid)
              this.clearData()
            }, 10000)
          }).catch(() => {
            this.sentClass = 'text-danger'
            this.message = 'Something went wrong please try again later.'
            this.timer = setTimeout(() => { this.clearData() }, 10000)
          })
        }
      })
    },
    modalACH (key) {
      return 'modalACH' + key
    },
    resetForm () {
      this.docRequest.DocumentTypes = []
      this.docRequest.Name = ''
      this.docRequest.Email = ''
      this.$validator.validateAll().then((result) => {
        this.$validator.pause()
        this.$nextTick(() => {
          this.$validator.errors.clear()
          this.$validator.fields.items.forEach(field => field.reset())
          this.$validator.fields.items.forEach(field => this.errors.remove(field))
          this.$validator.resume()
        })
      })
    }
  },
  mounted: function () {
    this.$root.$on('bv::modal::hide', (bvEvent, modalid) => {
      this.resetForm()
    })
    axios
      .get(this.apiUrl + auth.user.clientID + '/contracts/' + this.parentData + '/documents', {
        headers: auth.getAuthHeader()
      })
      .then(response => {
        this.documentsDisplay = response.data
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/modalDocuments.vue